import FormComponent from './pages/FormComponent';
import Payment from './pages/Payment';
import Done from './pages/Done';
import Error from './pages/Error';
import { createMemoryRouter } from 'react-router-dom';
import { WorkflowContextProvider } from './contexts/WorkflowContext';
import { NotFound } from './pages/NotFound';

export const routes = createMemoryRouter([
    {
        path: '/',
        element: (
            <WorkflowContextProvider>
                <FormComponent />
            </WorkflowContextProvider>
        ),
        errorElement: <NotFound />,
    },
    {
        path: '/payment',
        element: (
            <WorkflowContextProvider>
                <Payment />
            </WorkflowContextProvider>
        ),
        errorElement: <NotFound />,
    },
    {
        path: '/done',
        element: (
            <WorkflowContextProvider>
                <Done />
            </WorkflowContextProvider>
        ),
        errorElement: <NotFound />,
    },
    {
        path: '/error',
        element: (
            <WorkflowContextProvider>
                <Error />
            </WorkflowContextProvider>
        ),
        errorElement: <NotFound />,
    },
]);
